import React, { useState, useEffect } from 'react';
import { settingService } from '../../services/settingService';
import { FiSave } from 'react-icons/fi';

const Settings = () => {
  const [settings, setSettings] = useState({
    taxRate: 11,
    taxName: 'PPN',
    taxType: 'PPN',
    taxEnabled: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Load settings dari Supabase
  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const data = await settingService.getAll();
      setSettings({
        taxRate: parseFloat(data.taxRate) || 11,
        taxName: data.taxName || 'PPN',
        taxType: data.taxType || 'PPN',
        taxEnabled: data.taxEnabled === 'true' || data.taxEnabled === true
      });
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await settingService.updateBatch({
        taxRate: String(settings.taxRate),
        taxName: settings.taxName,
        taxType: settings.taxType,
        taxEnabled: String(settings.taxEnabled)
      });
      alert('✅ Setting pajak berhasil disimpan!');
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('❌ Gagal menyimpan setting: ' + (error.message || ''));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-[var(--text-secondary)]">Loading settings...</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-6">Pengaturan</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Card Pengaturan Pajak */}
        <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
          <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4 flex items-center gap-2">
            <span>Pengaturan Pajak</span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Aktifkan Pajak */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Aktifkan Pajak
              </label>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="taxEnabled"
                  checked={settings.taxEnabled}
                  onChange={handleChange}
                  className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                />
                <span className="text-sm text-[var(--text-secondary)]">
                  {settings.taxEnabled ? '✅ Aktif' : '❌ Nonaktif'}
                </span>
              </div>
              <p className="text-xs text-[var(--text-secondary)] mt-1">
  * Non-Aktif kan kalau tidak mau pakai pajak
</p>
            </div>

            {/* Nama Pajak */}
            <div>
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Nama Pajak
              </label>
              <input
                type="text"
                name="taxName"
                value={settings.taxName}
                onChange={handleChange}
                placeholder="PPN, PPH, VAT"
                className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Jenis Pajak */}
            <div>
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Jenis Pajak
              </label>
              <select
                name="taxType"
                value={settings.taxType}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="PPN">PPN</option>
                <option value="PPH">PPH</option>
                <option value="VAT">VAT</option>
                <option value="Lainnya">Lainnya</option>
              </select>
            </div>

            {/* Tarif Pajak */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Tarif Pajak (%)
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  name="taxRate"
                  value={settings.taxRate}
                  onChange={handleChange}
                  min="0"
                  max="100"
                  step="0.1"
                  className="flex-1 px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <span className="text-sm text-[var(--text-secondary)]">%</span>
              </div>
              <p className="text-xs text-[var(--text-secondary)] mt-1">
                * Contoh Pajak itu: PPN 11%, PPH 2.5%, dll. Isi 0 untuk tidak pakai pajak.
              </p>
            </div>
          </div>
        </div>

        {/* Tombol Submit */}
        <button
          type="submit"
          disabled={saving}
          className="flex items-center space-x-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors disabled:opacity-50"
        >
          <FiSave size={20} />
          <span>{saving ? 'Menyimpan...' : 'Simpan Pengaturan'}</span>
        </button>
      </form>
    </div>
  );
};

export default Settings;